import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";

import HomepageVersionSwitch from "../../SharedComponents/HomepageVersionSwitch";
import { SvgIcons } from "../../SharedComponents/SvgIcons/SvgIcons";
import useHomepageVersion from "../../hooks/useHomepageVersion";
import { HOMEPAGE_SWITCH_NAME } from "../../utils/homepageVersion";
import { selectDarkMode } from "../../Redux/Reducers/darkModeSlice";
import useHomepageUpgradeBanner from "./useHomepageUpgradeBanner";
import styles from "./style.module.css";

/**
 * Names the new experience and puts its switch in front of paid students for
 * three days, above /home. Rendered by App, which decides who sees it.
 */
const HomepageUpgradeBanner = () => {
  const { isNewHomepage } = useHomepageVersion();
  const { isVisible, dismiss } = useHomepageUpgradeBanner({ isNewHomepage });
  const isDarkMode = useSelector(selectDarkMode);

  if (!isVisible) return null;

  return (
    <div
      className={clsx(styles.banner, isDarkMode && styles.dark)}
      role="region"
      aria-label="Homepage update"
    >
      <div className={styles.content}>
        <p className={styles.name}>{HOMEPAGE_SWITCH_NAME}</p>
        <HomepageVersionSwitch source="banner" layout="inline" />
      </div>
      <button
        type="button"
        className={styles.close}
        onClick={dismiss}
        aria-label="Close"
      >
        <SvgIcons name="cross" width="14" height="14" />
      </button>
    </div>
  );
};

export default HomepageUpgradeBanner;
